import { GridFilterModel } from "@mui/x-data-grid";
import { GridApiCommunity } from "@mui/x-data-grid/internals";
import { MutableRefObject, useEffect } from "react";

export const useQuickFilterEffect = (
  filterModel: GridFilterModel,
  resetToFirstPage: () => void,
  apiRef: MutableRefObject<GridApiCommunity>,
  hasSetInitialQuickFilterRef: MutableRefObject<boolean>,
  isUpdatingQuickFilterRef: MutableRefObject<boolean>,
  timeoutRef: MutableRefObject<ReturnType<typeof setTimeout> | null>
) => {
  useEffect(() => {
    if (filterModel.quickFilterValues?.length) {
      resetToFirstPage();

      hasSetInitialQuickFilterRef.current = true;
      isUpdatingQuickFilterRef.current = true;

      apiRef.current?.setQuickFilterValues?.(filterModel.quickFilterValues);

      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = null;
      }

      timeoutRef.current = setTimeout(() => {
        if (timeoutRef.current !== null) {
          isUpdatingQuickFilterRef.current = false;
          timeoutRef.current = null;
        }
      }, 0);
    }

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = null;
      }
    };
  }, [filterModel.quickFilterValues, resetToFirstPage, apiRef]);
};
